import type { FaireProductEntity } from "../../entity_types/product";

export const p_63kwcnrwh6: FaireProductEntity = {
  token: "p_63kwcnrwh6",
  type: "product",
  name: "Sporta Laundry Bin - Nature",
  brandToken: "b_8qfvgpu7nc",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/bd18015beb973952c6a06d617655a2caaa4dee3456a7455801252b395246c92f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2eee5ad895158fc0bba6641c18a76ae260819482111f78027a866cf8640cfa50.jpeg",
    "https://cdn.faire.com/fastly/3b924f369a813d314ea67dd7ecd9856374962edc888f6b881ca14dac0d259a2f.jpeg",
  ],
  priceDollars: 56,
  description:
    'The Sporta Laundry Bin has a natural, simple and elegant look. With its classic design it will fit perfectly into your bedroom or bathroom, helping you to store your laundry in an elegant way.\n\nThe laundry bin is made of 100% natural bamboo, and the inner bag is made of 100% cotton.\n\nFor cleaning it is recommended to wipe with a dry cloth.\n\n\nColor: Nature\nQuality: 100% Bamboo\nDimensions: 13" x 22"\n',
  tags: [],
  msrpDollars: 112,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:34.987Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
